import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import { useMenu } from '../contexts/MenuContext';
import { formDataPost } from '../helpers/Helpers';
import withForm from '../layouts/withForm';
const Security2faEmailAuthentication = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    const [roles, setRoles] = useState({});   
    const [rolesArray, setRolesArray] = useState([]);   
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-roles",
                    method: 'GET'
                });
        
                // Save to localStorage
                localStorage.setItem("plusRoles", JSON.stringify(results));
        
                // Update state
                setRoles(results);
            } catch (error) {
                console.error("Error fetching roles:", error);
            }
        };
        
        // Check if data is already in localStorage
        const storedRoles = localStorage.getItem("plusRoles");
        if (storedRoles) {
            setRoles(JSON.parse(storedRoles));
        } else {
            fetchRoles();
        }
    }, []);
    
    useEffect(() => {
        const tempArray = Object.entries(roles).length && Object.entries(roles).map(([code, { name, count }]) => ({
            value: name, // name
            code: code, // Use the key as the code
        }));
        setRolesArray(tempArray)
    }, [roles])
    const [isEncrypted, setIsEncrypted] = useState(0);
    const [isEncryptedReset, setIsEncryptedReset] = useState(0);
    const [isEncryptedLoaded, setIsEncryptedLoaded] = useState(false);
    useEffect(() => {
        setIsEncryptedLoaded(false);
        const fetchEncrypted = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-enable-encryption-database-keys",
                    method: 'GET'
                });
        
                // Update state
                setIsEncrypted(results);
                setIsEncryptedLoaded(true);
        
            } catch (error) {
                console.error("Error fetching encryption database key:", error);
            }
        };       
        fetchEncrypted();
    }, []);

    const [processing, setProcessing] = useState(false)
    const [processingRing, setProcessingRing] = useState(false)
    const [processingTick, setProcessingTick] = useState(false)
    const [isEncryptedDone, setIsEncryptedDone] = useState(false);
    const encryptDbKeys = async () => {
        setProcessing(true);
        setProcessingRing(true);
        try {
            const result = await formDataPost("ultimate_security_enable_encryption_database_keys", {});
            if (result === true) {
                setProcessingRing(false);
                setProcessingTick(true)
                
                setTimeout(()=> {
                    setProcessingTick(false)
                    setProcessing(false)
                    setIsEncryptedDone(true)
                },1000)
            }
                
        } catch (error) {
            // console.log(error.message);
        } finally {
            setProcessing(false);
            setProcessingRing(false)
        }
    }

    return (
        <>
           
            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Email Verification", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Email Verification sends a login code to the user's email. While it helps protect weak or leaked passwords, it's less secure than other 2FA methods", "ultimate-security")}</p>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable/disable two-Factor authentication.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable Email Verification", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.2fa_authentication.email_authentication.2fa_email_verification_enable"
                                    checked={settingData?.security?.['2fa_authentication']?.['email_authentication']?.['2fa_email_verification_enable']} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                    valueType="string"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Allow grace period", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Allow a grace period for your users for the 2FA period.", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.security?.['2fa_authentication']?.['email_authentication']?.['2fa_email_verification_allow_grace_period']} 
                                        onChange={(e) => handleChange('security.2fa_authentication.email_authentication.2fa_email_verification_allow_grace_period', e.target.value)}
                                    >
                                        <option value="1">{__("1 day", "ultimate-security")}</option>
                                        <option value="5">{__("5 day", "ultimate-security")}</option>
                                        <option value="10">{__("10 day", "ultimate-security")}</option>
                                        <option value="30">{__("30 day", "ultimate-security")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="setting-unit pb-lg ">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Enable for:", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-start">
                                    <Hint position="top" content={__("No Hint", "ultimate-security")}/>    
                                    {
                                        rolesArray.length &&                                                                     
                                        <TagInput 
                                            name='security.2fa_authentication.email_authentication.2fa_email_verification_enable_for'
                                            type='role' 
                                            whitelist={rolesArray}
                                            initialTags={settingData?.security?.['2fa_authentication']?.['email_authentication']?.['2fa_email_verification_enable_for']} 
                                            handleChange={handleChange} 
                                        />
                                    }   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(Security2faEmailAuthentication, 'security.2fa_authentication.email_authentication');